import { put, takeLatest } from 'redux-saga/effects';
import { UserService } from './user.service';
import { userActions } from './index';
import { ApiResult } from 'common/models/api-service/api-result.model';

/**
 * Get User Profile Saga
 */
const getUserProfile = function* () {
    const { hasErrors, errors, value }: ApiResult<any> = yield UserService.getUserProfile();
    if (hasErrors) {
        yield put({
            type: userActions.getUserProfileError.type,
            payload: { error: errors }
        });
    } else {
        yield put({
            type: userActions.getUserProfileSuccess.type,
            payload: value
        });
    }
};

const getUserProfileWatch = function* () {
    yield takeLatest(userActions.getUserProfile.type, getUserProfile);
};

const getUserAvatar = function* () {
    const { hasErrors, errors, value }: ApiResult<Blob> = yield UserService.getUserImage();
    if (hasErrors) {
        yield put({
            type: userActions.getUserAvatarError.type,
            payload: ''
        });
    } else {
        yield put({
            type: userActions.getUserAvatarSuccess.type,
            payload: value ? URL.createObjectURL(value) : ''
        });
    }
};

const getUserAvatarWatch = function* () {
    // yield takeLatest(userActions.getUserProfile.type, getUserAvatar);
};

/**
 * Get User Info
 */
const getUserInfo = function* () {
    const { hasErrors, errors, value } = yield UserService.getUserInfo();
    if (hasErrors) {
        yield put({
            type: userActions.getUserInfoError.type,
            payload: { error: errors }
        });
    } else {
        yield put({
            type: userActions.getUserInfoSuccess.type,
            payload: value
        });
    }
};

const getUserInfoWatch = function* () {
    yield takeLatest(userActions.getUserInfo.type, getUserInfo);
};

export { getUserProfileWatch, getUserAvatarWatch, getUserInfoWatch };
